/* DRIF – opening hours, today's status, contact details and notice expiry.
   Source: #drif-hours-config, rendered by the "DRIF efsta lína" section.
   Iceland is UTC all year, so UTC time is shop time. */
(function () {
  function parseRange(text) {
    if (!text) return null;
    var m = String(text).match(/(\d{1,2})(?:[:.](\d{2}))?\D+(\d{1,2})(?:[:.](\d{2}))?/);
    if (!m) return null;
    return {
      open: Number(m[1]) + (m[2] ? Number(m[2]) / 60 : 0),
      close: Number(m[3]) + (m[4] ? Number(m[4]) / 60 : 0)
    };
  }
  function fmt(h) {
    var H = Math.floor(h);
    var M = Math.round((h - H) * 60);
    return H + ':' + (M < 10 ? '0' : '') + M;
  }
  function make(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function run() {
    var el = document.getElementById('drif-hours-config');
    if (!el) return;
    var cfg;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return; }

    var now = new Date();
    var today = now.toISOString().slice(0, 10);
    var day = now.getUTCDay();
    var t = now.getUTCHours() + now.getUTCMinutes() / 60;
    var key = day === 0 ? 'sun' : day === 6 ? 'sat' : day === 5 ? 'fri' : 'mon_thu';
    var exDate = (cfg.exDate || '').trim();
    var exEnd = (cfg.exEnd || '').trim() || exDate;
    var expired = exDate && today > exEnd;
    var hoursToday = cfg[key];
    if (exDate && today >= exDate && today <= exEnd && cfg.exHours) hoursToday = cfg.exHours;

    var r = parseRange(hoursToday);
    var text;
    var open = false;
    if (!r) text = 'Lokað í dag';
    else if (t < r.open) text = 'Opnum í dag kl. ' + fmt(r.open);
    else if (t < r.close) { open = true; text = 'Opið í dag til kl. ' + fmt(r.close); }
    else text = 'Lokað núna';
    document.querySelectorAll('[data-drif-status]').forEach(function (node) {
      node.textContent = text;
      var wrap = node.closest('[data-drif-status-wrap]');
      if (wrap) wrap.classList.toggle('is-open', open);
    });

    var digits = String(cfg.phone || '').replace(/[^\d]/g, '');
    document.querySelectorAll('[data-drif-field="phone"]').forEach(function (a) {
      a.textContent = cfg.phone || '';
      a.href = 'tel:+354' + digits;
      a.hidden = !cfg.phone;
    });
    document.querySelectorAll('[data-drif-field="email"]').forEach(function (a) {
      a.textContent = cfg.email || '';
      a.href = 'mailto:' + (cfg.email || '');
      a.hidden = !cfg.email;
    });
    document.querySelectorAll('[data-drif-field="address"]').forEach(function (n) {
      n.textContent = '';
      String(cfg.address || '').split(/,\s*/).forEach(function (part, i) {
        if (i) n.appendChild(document.createElement('br'));
        n.appendChild(document.createTextNode(part));
      });
    });

    document.querySelectorAll('[data-drif-hours]').forEach(function (list) {
      list.textContent = '';
      var rows = [['Mánudaga – fimmtudaga', cfg.mon_thu], ['Föstudaga', cfg.fri]];
      if ((cfg.sat || '') === (cfg.sun || '')) rows.push(['Laugardaga og sunnudaga', cfg.sat]);
      else { rows.push(['Laugardaga', cfg.sat]); rows.push(['Sunnudaga', cfg.sun]); }
      rows.forEach(function (row) {
        if (!row[1]) return;
        var li = make('li', 'drif-hours__row');
        li.appendChild(make('span', '', row[0]));
        li.appendChild(make('strong', '', row[1]));
        list.appendChild(li);
      });
    });

    document.querySelectorAll('[data-drif-hours-note]').forEach(function (n) {
      n.textContent = cfg.notice || '';
      n.hidden = !cfg.notice || expired;
    });

    if (expired) {
      document.querySelectorAll('[data-drif-notice]').forEach(function (n) { n.hidden = true; });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
